module.exports = __webpack_public_path__ + "img/widget_place.b6ece660.svg";